import { backgroundColors } from 'styles/colors'

export const dark = {
    color: '#a1a1a1',
    bgColor: `${backgroundColors.formPromo}`,
    bgColorHover: '#fff',
    overlayColor: '#333333a6',
}
